@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/greys';
@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/text';
@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/brand';
@forward '@raspberrypifoundation/design-system-core/scss/properties/border';

:host {
  --logo-leaf: var(--rpf-brand-leaf);
  --logo-outline: var(--rpf-brand-black);
  --logo-berry: var(--rpf-brand-raspberry);
  --logo-text: var(--rpf-brand-black);
  --logo-stroke: var(--logo-outline);
}

:host([theme='dark']) {
  --logo-leaf: var(--rpf-grey-850);
  --logo-outline: var(--rpf-white);
  --logo-berry: var(--rpf-grey-850);
  --logo-text: var(--rpf-white);
  --logo-stroke: transparent;
  --focus-border-color: var(--rpf-white);
}

:host([theme='clear']) {
  --logo-leaf: transparent;
  --logo-outline: var(--rpf-white);
  --logo-berry: transparent;
  --logo-text: var(--rpf-white);
  --logo-stroke: transparent;
  --focus-border-color: var(--rpf-white);
}

.rpf-logo {
  &__container {
    align-items: center;
    block-size: 2.375rem;
    display: flex;
    justify-content: center;
    outline-offset: 0;

    &:focus-visible {
      border-radius: var(--border-radius);
      outline: solid var(--border-width-md) var(--focus-border-color, --rpf-brand-raspberry);
    }

    @container (min-width: 22.5rem) {
      display: flex;
      inline-size: 7rem;
    }
  }

  &--lg {
    display: none;

    @container (min-width: 22.5rem) {
      display: flex;
    }
  }

  &--sm {
    display: flex;

    @container (min-width: 22.5rem) {
      display: none;
    }
  }

  &__leaf {
    fill: var(--logo-leaf);
  }

  &__berry {
    fill: var(--logo-berry);
  }

  &__outline {
    fill: var(--logo-outline);
    stroke: var(--logo-stroke);
  }

  &__text {
    fill: var(--logo-text);
  }
}
